import StoreContainer from "./StoreContainer";

class GroupStore {
  //The group specified in the boot config for the page. A prerouting rule can update this value
  //This is needed for any elements that always want to use the group specified for the page, like dynamic button
  private _pageGroupId: number;
  //The group currently being used in the active engagement, if there is one. Should be undefined if no engagemnt is active
  private _activeGroupId: number;

  initializePageGroupId(groupId: number) {
    this._pageGroupId = groupId;
  }

  async changePageGroupId(groupId: number) {
    if (this._pageGroupId === groupId) {
      return;
    }

    this._pageGroupId = groupId;

    //If we currently have an active group, it overrides whatever the page group is, so no need to consider reloading
    if (this._activeGroupId !== undefined) {
      return;
    }

    await StoreContainer.SettingStore.loadConfig();
    await StoreContainer.EngagementStore.loadSettings();
  }

  initializeActiveGroupId(groupId: number) {
    this._activeGroupId = groupId;
  }

  async changeActiveGroupId(groupId: number) {
    if (this._activeGroupId === groupId) {
      return;
    }

    var previousActiveGroup = this.getActiveOrPageGroupId();

    this._activeGroupId = groupId;

    if (previousActiveGroup === this.getActiveOrPageGroupId()) {
      return;
    }

    await StoreContainer.SettingStore.loadConfig();
    await StoreContainer.EngagementStore.loadSettings();
  }

  getPageGroupId() {
    if (this._pageGroupId === undefined) {
      throw new Error("groupId has not been set");
    }

    return this._pageGroupId;
  }

  getActiveOrPageGroupId() {
    if (this._activeGroupId !== undefined) {
      return this._activeGroupId;
    }

    return this.getPageGroupId();
  }

  hasActiveGroup() {
    return this._activeGroupId !== undefined;
  }

  activeAndPageGroupsDiffer() {
    return this.hasActiveGroup() && this._activeGroupId !== this._pageGroupId;
  }
}

export default GroupStore;
